export default "__VITE_ASSET__DSUUfHQd__"